import { render } from "./TheAdminProfessionalsList.vue?vue&type=template&id=418df97e&ts=true"
import script from "./TheAdminProfessionalsList.vue?vue&type=script&lang=ts"
export * from "./TheAdminProfessionalsList.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__